function formatNumberOrStringValue(value) {
  return typeof value === 'number' ? intToPx(value) : value;
}
function intToPx(int) {
  return `${Math.round(int)}px`;
}
function pxToInt(value) {
  const converted = parseInt(value, 10);
  return isNaN(converted) ? 0 : converted;
}

export { formatNumberOrStringValue, intToPx, pxToInt };
